import FoodCourt from './components';

export default {
  protected: true,
  path: '/foodcourts/:foodCourtId',
  key: '/foodcourt',
  exact: true,
  component: FoodCourt,
};
